import React from 'react';
import { motion } from 'framer-motion';
import { FaCreditCard, FaShieldAlt, FaHandshake, FaDollarSign } from 'react-icons/fa';

const PaymentInfo = ({ onContactClick }) => {
  const paymentOptions = [
    {
      icon: <FaShieldAlt size={40} />,
      title: "Medicaid & Insurance Through Brokers",
      description: "All insurance-related transportation, including Medicaid, is handled through approved brokers. We work with multiple Medicaid brokers and insurance brokers throughout Washington State. Your broker coordinates the transportation and handles all insurance verification and billing."
    },
    {
      icon: <FaHandshake size={40} />,
      title: "Broker Partnerships",
      description: "We maintain partnerships with healthcare facilities, assisted living communities, and medical providers throughout Washington State. If you're working with a facility or provider, they may coordinate transportation through us via their broker relationships."
    },
    {
      icon: <FaDollarSign size={40} />,
      title: "Private Pay",
      description: "We accept private pay for transportation services. Payment options include cash, credit cards, and debit cards. Contact us for pricing information and to discuss payment plans if needed."
    },
    {
      icon: <FaCreditCard size={40} />,
      title: "Direct Facility Billing",
      description: "We work directly with a majority of healthcare facilities, assisted living communities, and medical providers who arrange transportation for their patients or residents. Billing is handled directly with the facility."
    }
  ];

  return (
    <section className="payment-info" id="payment-info">
      <div className="container">
        <motion.div
          className="payment-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Payment Options</h2>
          <p>We work with brokers for all insurance-related transportation, and also accept private pay. All insurance and Medicaid transportation is coordinated through approved brokers who handle verification and billing.</p>
        </motion.div>

        <div className="payment-grid">
          {paymentOptions.map((option, index) => (
            <motion.div
              className="payment-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.02, 
                boxShadow: "0 10px 20px rgba(0,0,0,0.1)" 
              }}
            >
              <div className="payment-icon">{option.icon}</div>
              <h3>{option.title}</h3>
              <p>{option.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="payment-cta"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <p>For insurance or Medicaid transportation, please contact your assigned broker. For private pay or questions about our services, contact us directly.</p>
          <div className="cta-buttons">
            <button onClick={(e) => onContactClick && onContactClick(e)} className="cta-button">Contact Us</button>
            <a href="tel:3604823996" className="cta-button-secondary">Call (360) 482-3996</a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PaymentInfo;

